import React, { Component} from "react";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { weatherSearchLocation, getWeatherForcasteByLocation, getWeatherSpecificByLocation } from '../../../../../../../actions/sceneActions'
const duplicationRemoveFromArray = (data) => {
    let removeableData = [];
    let existingDataID = [];
    if (data && data.length > 0) {
        data.map((item) => {
            if (!existingDataID.includes(item.label)) {
                existingDataID.push(item.label);
                removeableData.push(item);
            }

        })
    }
    return removeableData;
}

class WeatherSelect extends Component {
    state = {
        isLoading: false,
        options: [],
        selectedLoaction: null
    }
    componentDidMount() {
        const { selectedOption, updateApi } = this.props;
        if (updateApi && selectedOption) this.setState({ selectedLoaction: selectedOption }, () => this.onGetWeatherFromLocation())
    }

    handleSearch = async (query) => {
        this.setState({ isLoading: true })

        await weatherSearchLocation(query).then((response) => {
            const { results } = response.data;
            let optionsData = [];
            if (results && results.length > 0) {
                results.map((item) => {
                    optionsData.push({ id: item.Key, value: item.Key, label: item.LocalizedName })
                })

            }
            this.setState({ options: duplicationRemoveFromArray(optionsData), locationSearchData: results, isLoading: false })

            return response.data
        })

    };

    onSelectedLocation = (selected) => {
        this.setState({ selectedLoaction: selected }, () => this.onGetWeatherFromLocation())
    }
    onGetWeatherFromLocation = async () => {
        const { languageValue, temperatureUnitText } = this.props;
        const { selectedLoaction } = this.state;
        if (selectedLoaction && selectedLoaction.length > 0 && Object.keys(selectedLoaction).length > 0 && selectedLoaction[0].value) this.props.onUpdateLocation(selectedLoaction);
        if (selectedLoaction && selectedLoaction.length > 0 && Object.keys(selectedLoaction).length > 0 && selectedLoaction[0].value && languageValue && temperatureUnitText) {
            await getWeatherForcasteByLocation(selectedLoaction[0].value, languageValue, temperatureUnitText).then((response) => {
                const data = response.data[selectedLoaction[0].value];
                this.props.onUpdateWeatherData(data)
            })
            await getWeatherSpecificByLocation(selectedLoaction[0].value).then((response) => {
                const data = response.data[selectedLoaction[0].value];
                this.props.onUpdateCurrentData(data)
            })
        }
    }


    render() {
        const { isLoading, options, selectedLoaction } = this.state;
        const filterBy = () => true;
        return <AsyncTypeahead
            selected={selectedLoaction}
            onChange={this.onSelectedLocation}
            filterBy={filterBy}
            id="async-example"
            isLoading={isLoading}
            labelKey="label"
            minLength={3}
            onSearch={this.handleSearch}
            options={options}
            placeholder="Search for a location..."
            renderMenuItemChildren={(option, props) => <span>{option.label}</span>
            }
        />
    }
}

export default WeatherSelect;